import { Check } from "lucide-react";
import type { QuoteKey, University } from "@/lib/universities";

const QUOTE_COLUMNS: { key: QuoteKey; label: string }[] = [
  { key: "abq", label: "ABQ" },
  { key: "adh", label: "AdH" },
  { key: "zeq", label: "ZEQ" },
];

export default function CriteriaTable({ university }: { university: University }) {
  if (!university.criteria) return null;
  return (
    <div className="rounded-xl bg-paper-deep/40 overflow-hidden">
      <table className="w-full text-sm">
        <thead>
          <tr>
            <th className="text-left font-bold px-4 pt-3.5 pb-2.5 text-xs uppercase tracking-widest text-ink-faint">
              Kriterien
            </th>
            {QUOTE_COLUMNS.map((quote) => (
              <th
                key={quote.key}
                className="font-bold px-2 pt-3.5 pb-2.5 text-xs uppercase tracking-widest text-ink-faint w-14 text-center"
              >
                {quote.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {university.criteria.map((criterion) => (
            <tr key={criterion.name} className="border-t border-line">
              <td className="px-4 py-2 text-ink">{criterion.name}</td>
              {QUOTE_COLUMNS.map((quote) => (
                <td key={quote.key} className="px-2 py-2 text-center">
                  {criterion.quotes.includes(quote.key) ? (
                    <Check size={15} className="inline text-mint" aria-label="Ja" />
                  ) : (
                    <span className="text-line select-none" aria-hidden="true">
                      –
                    </span>
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
